<template>
  <modal :show.sync="showModal" header-classes="justify-content-center" @close="handleClose">
    <h4 slot="header" class="title title-up">
      Transfer A Disciple
    </h4>
    <h2 v-if="error" style="color:red;">
      There was an error. Please refresh your page.
    </h2>
    <span v-else>
      <el-row>
        <label class="col-md-4 col-form-label">Disciple To Transfer</label>
        <el-select
          class="col-md-8 select-default"
          filterable
          clearable
          v-model="transferredDisciplePersonId"
          placeholder="Select disciple..."
        >
          <el-option
            v-for="item in transferrableDisciples"
            :key="item.id"
            :label="item.name"
            :value="item.id"
          />
        </el-select>
      </el-row>
      <br>
      <el-row>
        <label class="col-md-4 col-form-label">New Discipler</label>
        <el-select
          class="col-md-8 select-default"
          filterable
          clearable
          v-model="newDisciplerPersonId"
          placeholder="Select new discipler..."
        >
          <el-option
            v-for="item in addableDisciplers"
            :key="item.id"
            :label="item.name"
            :value="item.id"
          />
        </el-select>
      </el-row>
    </span>
    <p v-if="validationError === true" style="color: red;">
      A disciple is required.
    </p>
    <br><br>
    <template slot="footer">
      <p-button @click.native="handleClose">
        Cancel
      </p-button>
      <p-button type="danger" v-if="!saving" @click.native="handleSave">
        Transfer Disciple
      </p-button>
      <p-button type="danger" v-if="saving">
        Saving...
      </p-button>
          &nbsp;&nbsp;
    </template>
  </modal>
</template>

<script>
import { mapState, mapActions, vuex } from 'vuex';
import Modal from '../UIComponents/Modal';

import { RepositoryFactory } from '../../repositories/repositoryFactory';

const DisciplesRepository = RepositoryFactory.get('disciples');

function validateForm(transferredDisciplePersonId, newDisciplerPersonId) {
    return !!transferredDisciplePersonId && !!newDisciplerPersonId;
}

export default {
    name: 'TransferDiscipleModal',
    components: {
        Modal
    },
    data() {
        return {
            showModal: false,
            material: '',
            validationError: false,
            transferrableDisciples: [],
            addableDisciplers: [],
            transferredDisciplePersonId: '',
            newDisciplerPersonId: '',
            error: '',
            saving: false
        };
    },
    computed: {

    },
    methods: {
        handleSave() {
            this.saving = true;
            if (!validateForm(this.transferredDisciplePersonId, this.newDisciplerPersonId)) {
                this.validationError = true;
                this.saving = false;
                return;
            }

            DisciplesRepository.transferDisciple(this.transferredDisciplePersonId, this.newDisciplerPersonId)
            // axios.post('/disciples/transfer',
            //     {
            //         disciple_person_id: this.transferredDisciplePersonId,
            //         new_discipler_person_id: this.newDisciplerPersonId
            //     },
            //     { headers: { Authorization: this.$store.getters.token } })
                .then((response) => {
                    this.saving = false;
                    this.$emit('discipleChange');
                    this.$message(response.data.message);
                })
                .catch((error) => {
                    this.saving = false;
                    this.$message(error.response.data.message);
                });

            this.$message('Updating Disciple Tree.');
            this.$emit('save', this.title);
            this.$emit('close');

            this.transferredDisciplePersonId = '';
            this.newDisciplerPersonId = '';
            this.validationError = false;
        },
        handleClose() {
            this.transferredDisciplePersonId = '';
            this.newDisciplerPersonId = '';
            this.validationError = false;
            this.$emit('close');
        },
        getTransferrableDisciplesList() {
            DisciplesRepository.getTransferrableDisciplesList()
                .then((response) => {
                    this.transferrableDisciples = response.data.data;
                })
                .catch((error) => {
                    this.error = error;
                });
        },
        getAddableDisciplersList() {
            DisciplesRepository.getAddableDisciplersList()
                .then((response) => {
                    this.addableDisciplers = response.data.data;
                })
                .catch((error) => {
                    this.error = error;
                });
        },
    },
    props: {
        show: Boolean,
    },
    watch: {
        show(val) {
            this.showModal = val;
            if (this.showModal === true) {
                this.getTransferrableDisciplesList();
                this.getAddableDisciplersList();
            }
        }
    },
    created() {
        // this.getTransferrableDisciplesList();
        // this.getAddableDisciplersList();
    }

};
</script>
